import { render, staticRenderFns } from "./PageABCBookFailed.vue?vue&type=template&id=2ec47d56&scoped=true&"
import script from "./PageABCBookFailed.vue?vue&type=script&lang=js&"
export * from "./PageABCBookFailed.vue?vue&type=script&lang=js&"
import style0 from "./PageABCBookFailed.vue?vue&type=style&index=0&id=2ec47d56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec47d56",
  null
  
)

export default component.exports